import { getContainersAboveNav } from './getContainersAboveNav';
export function getExternalBannersHeight() {
  let totalHeight = 0;
  const containersAboveNav = getContainersAboveNav();
  Object.values(containersAboveNav).forEach(container => {
    const containerHeight = container ? container.getBoundingClientRect().height : 0;
    totalHeight += containerHeight;
  });
  return totalHeight;
}